import { combineReducers } from 'redux';
import file from './file';
import modal from './modal';
import cardCatalog from './cardCatalog';
import recipients from './recipients';
import cardCustomizationBar from './cardCustomizationBar';
import formHistory from './formHistory';
import trackedEvents from './tracking';
import drafts from './draftsReducer';
import orders from './ordersReducer';
import project from './projectReducer';
import notes from './notesReducer';
import { preview } from './digitalPreview';
import { reducer as customization } from './customization';
import { reducer as pdp } from './pdp';

const cards = combineReducers({
  cardCustomizationBar,
  cardCatalog,
  project,
  notes,
  drafts,
  orders,
  file,
  modal,
  recipients,
  formHistory,
  trackedEvents,
  preview,
  customization,
  pdp
});

export default cards;



// WEBPACK FOOTER //
// ./src/cards/reducers/index.js